import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

const NoSnowflakeAssociated = () => {
  const user = useSelector((state) => state.user);
  const { Roles } = user.currentUser;

  return (
    <div style={{ minHeight: "300px", display: "flex", justifyContent: "center", alignItems: "center" }}>
      No snowflake account associated.{" "}
      {Roles.includes("SysAdmin") && (
        <>
          Please
          <Link to="/connections/snowflake" style={{ marginLeft: "4px" }}>
            associate snowflake account.
          </Link>
        </>
      )}
    </div>
  );
};

export default NoSnowflakeAssociated;
